/**
 * Validates an NPI number using the Luhn algorithm.
 * NPI is a 10-digit number where the prefix "80840" is prepended
 * for the Luhn check (making it 15 digits).
 */
export function isValidNPI(npi: string): boolean {
  if (!/^\d{10}$/.test(npi)) return false;

  const prefixed = "80840" + npi;
  let sum = 0;
  let alternate = false;

  for (let i = prefixed.length - 1; i >= 0; i--) {
    let n = parseInt(prefixed[i], 10);
    if (alternate) {
      n *= 2;
      if (n > 9) n -= 9;
    }
    sum += n;
    alternate = !alternate;
  }

  return sum % 10 === 0;
}
